import axios from "axios";
import { DateRangePicker } from "react-date-range";
import { useState, useEffect } from "react";
import PieChartOrder from "../PieChartOrder/PieChartOrder";

const Countrygraph = () => {
  const baseAPI = process.env.REACT_APP_API_URL;

  const [isOrderStatusPicker, setisOrderStatusPicker] = useState(false);
  const [dateRangeStatus, setDateRangeStatus] = useState("Select Date Range");
  const [totalOrderStatus, setTotalOrderStatus] = useState(0);
  const [OrderStatusData, setOrderStatusData] = useState([]);
  const [colorsOrders, setColorsOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}userget/GetDashboardOrderStatus?startDate=&enddate=`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response && response.data && response.data.data) {
            setOrderStatusData(response.data.data);
            setColorsOrders(generateColorsOrderStatus(response.data.data));
            setTotalOrderStatus(response.data.totalRecords);
            setSelectionRangeStage({
                startDate: new Date(),
                endDate: new Date(),
                key: "selection",
              });
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);
 

  const [selectionRangeStage, setSelectionRangeStage] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });

  const handleSelectOrder = (ranges) => {
    setSelectionRangeStage({
        startDate: ranges.selection.startDate,
        endDate: ranges.selection.endDate,
        key: "selection",
      });
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const toggleLeadStagePicker = () => {
    setisOrderStatusPicker(!isOrderStatusPicker);
   
  };

  function generateColorsOrderStatus(data) {
    // Convert to an array if it's not already one
    const arrayData = Array.isArray(data) ? data : Array.from(data);

    const colorMapping = {};
    arrayData.forEach((item) => {
      colorMapping[item.Order_Status] =
        "#" + Math.floor(Math.random() * 16777215).toString(16);
    });
    return colorMapping;
  }

  const closeFilterOrderStatus = () => {
    setisOrderStatusPicker(!isOrderStatusPicker);
  };

  const OrderStatusApplyButton = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    let cdate = formatDate(new Date());
    let startdate = selectionRangeStage.startDate
      ? formatDate(selectionRangeStage.startDate)
      : "";
    let enddate = selectionRangeStage.endDate
      ? formatDate(selectionRangeStage.endDate)
      : "";

    if (startdate === cdate && enddate === cdate) {
        setDateRangeStatus("Select Date Range");
      startdate = "";
      enddate = "";
    } else {
        setDateRangeStatus(startdate + " - " + enddate);
    }

    toggleLeadStagePicker();
    if (isOrderStatusPicker) {
      setisOrderStatusPicker(!isOrderStatusPicker);
    } else {
      setisOrderStatusPicker(isOrderStatusPicker);
    }

    if (storedToken) {
      setLoading(true);
      axios
        .get(
          `${baseAPI}userget/GetDashboardOrderStatus?startDate=${startdate}&endDate=${enddate}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          if (response && response.data && response.data.data) {
            setOrderStatusData(response.data.data);
            setTotalOrderStatus(response.data.totalRecords);
            setColorsOrders(generateColorsOrderStatus(response.data.data));
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching user detail:", error);
        });
    }
  };

  return (
    <>
      <div className="outerFilterLeadStage">
        <div className="outerFilter">
          <div className="filter-icon-source">
            <img src={require("../../../Icons/filterIcon.png")} alt="filter" />
            FILTER
          </div>

          <div style={{ paddingRight: "6px" }}>
            <button
              style={{
                marginBottom: "1rem",
                width: "8rem",
                height: "2.5rem",
                borderRadius: "0.5rem",
                fontSize: "11px",
              }}
              onClick={toggleLeadStagePicker}
            >
              {" "}
              <b> {dateRangeStatus}</b>
            </button>
            {isOrderStatusPicker && (
              <div
                style={{
                  position: "absolute",
                  zIndex: 999,
                  border: "solid 1px black",
                  marginLeft: "-13pc",
                  marginTop: "-3pc",
                  width: "35pc",
                  background: "white",
                }}
              >
                <DateRangePicker
                  ranges={[selectionRangeStage]}
                  onChange={handleSelectOrder}
                />

                <button
                  onClick={OrderStatusApplyButton}
                  style={{
                    marginBottom: "1rem",
                    width: "8rem",
                    height: "2.5rem",
                    borderRadius: "0.5rem",
                    fontSize: "13px",
                    position: "relative",
                    top: "1px",
                    left: "17pc",
                    backgroundColor: "#5B489D",
                    color: "White",
                    border: "none",
                  }}
                >
                  Apply Filter
                </button>
                <button
                  onClick={closeFilterOrderStatus}
                  style={{
                    marginBottom: "1rem",
                    width: "7.5rem",
                    height: "2.5rem",
                    borderRadius: "0.5rem",
                    fontSize: "13px",
                    position: "relative",
                    top: "1px",
                    left: "17pc",
                    color: "red",
                    backgroundColor: "white",
                    border: "none",
                    fontWeight: "bold",
                  }}
                >
                  Close
                </button>
              </div>
            )}
          </div>

          <div>
            <button
              style={{
                width: "9rem",
                height: "2.5rem",
                borderRadius: "0.5rem",
                fontSize: "12px",
                backgroundColor: "#5B489D",
                color: "white",
                fontWeight: "bold",
              }}
              onClick={OrderStatusApplyButton}
            >
              Apply
            </button>
          </div>
        </div>

        <div className="leadSourceListButton">
          <p>
            {" "}
            <b> Total: </b>{" "}
            <span style={{ color: "#5B489D" }}>
              <b>{totalOrderStatus}</b>
            </span>
          </p>
        </div>
      </div>
      <hr style={{ background: "red" }} />

      <h3
        style={{
          fontSize: "25px",
          padding: "9px",
          fontWeight: "700",
          color: "#6A6A6A",
        }}
      >
        Order Status
      </h3>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "60%",
            display: "flex",
            marginLeft: "0%",
          }}
        >
          <PieChartOrder data={OrderStatusData} colors={colorsOrders} />
        </div>
        <div className="Lead_stagetable" style={{ marginLeft: "10px" }}>
          <table style={{ width: "17.5rem" }}>
            <hr />

            {Array.isArray(OrderStatusData) && OrderStatusData.length > 0 ? (
              OrderStatusData.map((item, index) => (
                <tr style={{ borderBottom: "1px solid #ccc" }} key={index}>
                  <td>
                    <ul>
                      <span
                        style={{
                          color: colorsOrders[item.Order_Status],
                          fontWeight: "bold",
                        }}
                      >
                        &#9679;
                      </span>{" "}
                      {item.Order_Status}
                    </ul>
                  </td>
                  <td>{item.Count_RelocationId}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td>No data available</td>
              </tr>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

export default Countrygraph;
